(function($){

  OH.infoViewer = function($parent, prefix){
    if(OH.infoViewer.serial == null){
      OH.infoViewer.serial = 0;
    }
    var taskID = "infoviewer" + OH.infoViewer.serial++;
    var panel = $parent.get(0);

    var controller = {
      left : panel.querySelector('.' + prefix + '__control.is-left'),
      right : panel.querySelector('.' + prefix + '__control.is-right')
    };


    var list = panel.querySelector('.' + prefix + '__list');
    var listItem = panel.querySelector('.' + prefix + '__list__item');

    var setControllerActivity = function(){
      var canScroll = list.scrollWidth > list.clientWidth;
      var activity = {
          left : (canScroll && list.scrollLeft > 0),
          right : (canScroll && (list.scrollLeft + list.clientWidth < list.scrollWidth))
      };
      controller.left.style.opacity = canScroll ? activity.left ? 1 : 0.2 : 0;
      controller.right.style.opacity = canScroll ? activity.right ? 1 : 0.2 : 0;
    };
    if(navigator.userAgent.toLowerCase().search(/iphone|ipad|android/) != -1){
      $(list).css({'overflow-x':'auto'});
      //  $(list).css({'overflow-x':'auto', '-webkit-overflow-scrolling' : 'touch'});
    }

    var scrollShift = function(direction){
      // var scrollTo = direction * listItem.clientWidth;
      var scrollTo = Math.max(0, Math.min(list.scrollLeft + (direction > 0 ? 1 : -1) * list.clientWidth * (2/5), list.scrollWidth - list.clientWidth));
      $(list).animate({scrollLeft : scrollTo}, 200);
    };
    $(controller.left).on("click", function(){
      scrollShift(-1);
    });
    $(controller.right).on("click", function(){
      scrollShift(1);
    });

    /**
     *ドットのナビ作成
     *  infoViewerに追加機能やらないほうがいい
     */
    // var navigationIndicator = function(){
    //   var indicatorLengrh = list.childElementCount;
    //   var $indicatorDots = '';//span要素を格納する用
    //   for (var i = 1; i <= indicatorLengrh; i++) {
    //     $indicatorDots += '<span class="' + prefix + '__indicator_wrap__dots" data-indication-'+ i +'></span>';
    //   }
    //   var $indicator = '<div class="'+ prefix +'__indicator_wrap">'+ $indicatorDots +'</div>';
    //   $parent.append($indicator);
    // }();

    $(list).on("scroll", setControllerActivity);
    OH.onResizeTasks.append(taskID, setControllerActivity,true);

  };

})(jQuery);
